import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class GridPricingFile {

  public static build(
    durationYear: number,
    name: string,
    originalContent: string): GridPricingFile {
    const file: GridPricingFile = new GridPricingFile();
    file.durationYear = durationYear;
    file.name = name;
    file.originalContent = originalContent;
    return file;
  }

  public durationYear: number | null = 1;
  public name: string | null = 'gridMyFilePricing';
  public originalContent: string | null = null;

  public constructor(options: ObjectOnly = {}) {
    if (options) {
      assignToThis(this, options);
    }
  }

}
